import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import {
  StyledFeature,
  StyledFeatureArrow,
  StyledFeatureContent,
  StyledFeatureFigure,
  StyledFeatureStat,
  StyledFeatureStats,
  StyledFeatureTitle,
  StyledFeatures,
  StyledHeader,
  StyledWrapper
} from './ConsultancyFeatures.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import {
  faCalendarAlt,
  faSync,
  faArrowRight,
  faFrown,
  faSmile,
  faTimesCircle,
  faCheckCircle
} from '@fortawesome/pro-light-svg-icons';
import {
  faTimesCircle as negativeFlagIcon,
  faCheckCircle as positiveFlagIcon
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import BadgeFlag from 'components/shared/BadgeFlag';

type featureType = {
  title: string;
  desc: string;
  highNumber: string;
  highFlag: string;
  lowNumber: string;
  lowFlag: string;
  highIcon: IconProp;
  lowIcon: IconProp;
};

const ConsultancyFeatures: React.FC = () => {
  const { t } = useI18n('consultancy');

  const features: featureType[] = [
    {
      title: t('consultancy.features.rotation.title'),
      desc: t('consultancy.features.rotation.desc'),
      highNumber: t('consultancy.features.rotation.high'),
      highFlag: t('consultancy.features.rotation.highFlag'),
      highIcon: faSync,
      lowNumber: t('consultancy.features.rotation.low'),
      lowFlag: t('consultancy.features.rotation.lowFlag'),
      lowIcon: faSync
    },
    {
      title: t('consultancy.features.time-to-market.title'),
      desc: t('consultancy.features.time-to-market.desc'),
      highNumber: t('consultancy.features.time-to-market.high'),
      highFlag: t('consultancy.features.time-to-market.highFlag'),
      highIcon: faCalendarAlt,
      lowNumber: t('consultancy.features.time-to-market.low'),
      lowFlag: t('consultancy.features.time-to-market.lowFlag'),
      lowIcon: faCalendarAlt
    },
    {
      title: t('consultancy.features.nps.title'),
      desc: t('consultancy.features.nps.desc'),
      highNumber: t('consultancy.features.nps.high'),
      highFlag: t('consultancy.features.nps.lowFlag'),
      highIcon: faFrown,
      lowNumber: t('consultancy.features.nps.low'),
      lowFlag: t('consultancy.features.nps.highFlag'),
      lowIcon: faSmile
    },
    {
      title: t('consultancy.features.productivity.title'),
      desc: t('consultancy.features.productivity.desc'),
      highNumber: t('consultancy.features.productivity.high'),
      highFlag: t('consultancy.features.productivity.lowFlag'),
      highIcon: faTimesCircle,
      lowNumber: t('consultancy.features.productivity.low'),
      lowFlag: t('consultancy.features.productivity.highFlag'),
      lowIcon: faCheckCircle
    }
  ];

  return (
    <StyledWrapper>
      <StyledHeader>
        <Heading2 editorial>{t('consultancy.features.title')}</Heading2>
        <HtmlTrans ns={'consultancy'} i18nKey={'consultancy.features.desc'} />
      </StyledHeader>
      <StyledFeatures>
        {features.map((feature, index) => (
          <StyledFeature key={index}>
            <StyledFeatureTitle>{feature.title}</StyledFeatureTitle>
            <StyledFeatureContent>
              <div>
                <HtmlTrans ns="consultancy" i18nKey={feature.desc} />
              </div>
              <StyledFeatureStats>
                <StyledFeatureStat>
                  <StyledFeatureFigure className="high">
                    <FontAwesomeIcon icon={feature.highIcon} />
                    <span>{feature.highNumber}</span>
                  </StyledFeatureFigure>
                  <BadgeFlag
                    text={feature.highFlag}
                    icon={negativeFlagIcon}
                    color={'negative'}
                  />
                </StyledFeatureStat>
                <StyledFeatureArrow>
                  <FontAwesomeIcon icon={faArrowRight} />
                </StyledFeatureArrow>
                <StyledFeatureStat>
                  <StyledFeatureFigure className="low">
                    <FontAwesomeIcon icon={feature.lowIcon} />
                    <span>{feature.lowNumber}</span>
                  </StyledFeatureFigure>
                  <BadgeFlag
                    text={feature.lowFlag}
                    icon={positiveFlagIcon}
                    color={'positive'}
                  />
                </StyledFeatureStat>
              </StyledFeatureStats>
            </StyledFeatureContent>
          </StyledFeature>
        ))}
      </StyledFeatures>
    </StyledWrapper>
  );
};

export default ConsultancyFeatures;
